import { useEffect, useState } from "react";
import { useFormState } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Flex from "../../../../components/Flex/Flex";
import Label from "../../../ui/components/Label/Label";
import themeColors from "../../../ui/constants/themeColors";
import useVisibleNodes from "../../../ui/hooks/useVisibleNodes";

export default function FormValidationMessageSticky({ name, height = 50 }) {
	const [nodes, setNodes] = useState([]);

	const { errors } = useFormState({ name });

	useEffect(() => {
		const names = findAll(errors, "ref").map(({ name }) => name);
		const errorNodes = names.map((errorName) => document.querySelector(`[name="${errorName}"]`)).filter(Boolean);

		setNodes(errorNodes);
	}, [errors]);

	const { aboveNodes, belowNodes } = useVisibleNodes({ nodes });

	return (
		<>
			{aboveNodes.length > 0 && <Message count={aboveNodes.length} height={height} position="above" />}

			{belowNodes.length > 0 && <Message count={belowNodes.length} height={height} position="below" />}
		</>
	);
}

function Message({ count, height, position }) {
	const { t } = useTranslation();

	return (
		<Flex
			justifyContent="center"
			style={{
				position: "sticky",
				left: 0,
				height,
				top: position === "above" ? 0 : `calc(100% - ${height}px)`,
				zIndex: 1200,
				marginBottom: -height,
				backgroundImage: `linear-gradient(${position === "above" ? "to bottom" : "to top"}, ${
					themeColors.RED_FADED
				}, transparent)`,
				color: themeColors.RED,
			}}
		>
			<Label color="red">{t("thereAreMoreErrors", "There are {{count}} more errors", { count })}</Label>
		</Flex>
	);
}

function findAll(object, key = "ref") {
	let results = [];

	if (object && typeof object === "object") {
		for (const k in object) {
			if (k === key && object[k]) {
				results.push(object[k]);
			} else {
				results = results.concat(findAll(object[k], key));
			}
		}
	}

	return results;
}
